import { render, staticRenderFns } from "./DashKpiCard.vue?vue&type=template&id=05320800&"
import script from "./DashKpiCard.vue?vue&type=script&lang=js&"
export * from "./DashKpiCard.vue?vue&type=script&lang=js&"
import style0 from "./DashKpiCard.vue?vue&type=style&index=0&id=05320800&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports